export default __webpack_public_path__ + "static/media/Insta-Icon.81809f3f.svg";